let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5ODd0")).then(() => parcelRequire('cpSf8'));